export const LOCAL = 'local';
export const DEVELOPMENT = 'development';
export const STAGING = 'staging';

type local = typeof LOCAL;
type development = typeof DEVELOPMENT;
type staging = typeof STAGING;
type nonProdEnvs = local | development | staging;

export function envIs(...envs: nonProdEnvs[]) {
  const env = process.env['NODE_ENV'] ?? '';
  return (envs as string[]).includes(env);
}

export function envIsDev() {
  const envs = [LOCAL, DEVELOPMENT];
  const env = process.env['NODE_ENV'] ?? '';
  return (envs as string[]).includes(env);
}
